import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import createDynamicRouter from './router'

import 'boxicons/css/boxicons.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@mdi/font/css/materialdesignicons.min.css'

async function initializeApp() {
    const app = createApp(App)

    app.config.errorHandler = (err, vm, info) => {
        console.error('Erreur capturée globalement:', err);
        console.log('Composant:', vm);
        console.log('Information:', info);
    };

    const pinia = createPinia()
    app.use(pinia)

    const router = await createDynamicRouter()
    app.use(router)
    app.use($);

    app.provide('app_name', 'Pension au poil');
    app.mount('#app')
}
initializeApp();
